import React, { Component } from 'react';


import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ActivityModal from './activity-modal';
import { fetchhoslogsWorkdays, filterAction,resetFilterAction } from '../actions/index';
import * as apiConstants from '../../../constants/const';
import HoursOfServiceModal from './hours-of-service-modal';
import HOSLogWorkDay from './hos-logs-workday';
import CommentsModal from './comments-modal';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/src/SuperResponsiveTableStyle.css';
import AdminCommonSection from '../components/adminLayout';
import {Filters, Pagination, constants, KeolisSpinner} from './common/commonExport';
import PDFPrinting from './PDFPrinting';


class HOSLogsWorkDays extends React.Component {

    constructor(props) {
      
        super(props);
        this.state = {
            totalRecords: '',
            numberOfPages: '',
            pageNum: 1, 
            filterState:{} 
        };
    }
    // get data for component
    getData(pageNum, filterObj){

        let status = this.props.queryParams.status;
        let greater12 = this.props.queryParams.greater12;
      
        if(filterObj){
            filterObj = filterObj;
        } else {
            filterObj = this.state.filterState;
        }
        filterObj["menustatus"] = status ? status : '';
        filterObj["greater12"] = greater12 ? '1' : '';
        let self = this,
            authDetails = this.props.authDetails,
            role = authDetails.role;
            pageNum = filterObj.byPagination ? (pageNum) : (filterObj.byFilter ? 1 : pageNum);     
     
        if(role == constants.roles.ADMIN_ROLE){
            let fetchObj = { 
                url: constants.actionUrls.ADMIN_HOS_LOGS_URL,
                role: role,
                certifyStatus: constants.ADMIN_HOS_LOG,//ADMIN_HOS_LOG ,// constants.ADMIN_HOS_LOG : 
                pageNum:pageNum,
                filterObj:filterObj
            }
            this.props.fetchhoslogsWorkdays(fetchObj, (response)=>{
              
                self.setState({
                    numberOfPages: response.totalPages,
                    pageNum: pageNum
                })}    
       
            );
            localStorage.setItem('route', constants.ADMIN_HOS_LOG);
        }
    };
    // resetting the filter component
    resetFilter(filterObj){
        let self = this;   
        filterObj["outlaw"] = false;
        this.props.resetFilter(filterObj, function(response){
            self.setState({
                filterState:response
            });
        });
    }
    //called before the component renders
    componentWillMount() {
        
        let filterObj = this.props.filterState.defaultState ? this.props.filterState.defaultState:
                        this.props.filterState;
        this.resetFilter(filterObj);
    }
    //called after the component rendered
    componentDidMount(){
        
        let pageNum = this.state.pageNum;
        this.getData(pageNum);
    }    

    renderModal() {

        if (this.props.showModal && (this.props.modalName == constants.hosModals.Certified_Modal || this.props.modalName == constants.hosModals.Certify_Modal)) {
            return (
                <ActivityModal isLogUser = {true} islogAdmin = {true}/>
            );
        }
    }
    // rendering pagination component
    renderPagination() {
        let { pageNum, numberOfPages} = this.state,
        workdays = this.props.workdays, showPagination=false;
        if(workdays && workdays.length > 0 && numberOfPages > 0){
            showPagination = true;
        }
        return (<Pagination ShowPagination={showPagination} currentPage={pageNum}
            pageSize={numberOfPages} GetData={(pageNum, filterObj) => this.getData(pageNum, filterObj)} />)
    }
    // rendering claimed workdays component
    renderWorkdays(){
        
        var ext_first_key, wdy_date, then, role = this.props.authDetails.role;
        if (this.props.isLoading) {
            return(
                <tr>
                    <td>
                       <KeolisSpinner />
                    </td>
                </tr>
            );
        }
        else if (this.props.workdays && this.props.workdays.length >= 0) {
            var workdays = this.props.workdays;
            let greater12 = this.props.queryParams.greater12 ? true : false            
            return(
                workdays.length == 0 ?
                <tr>
                    <td colSpan="100%">
                        No records available...
                    </td>
                </tr>
                :
                workdays.map(function (workday, index) {
                    return (
                        <HOSLogWorkDay workday={workday} key={index}  role = {role} greater12 = {greater12}/>
                    );
                })
            );
        } 
        else {
            return(
                <tr>
                    <td>
                        <KeolisSpinner />
                    </td>
                </tr>
            )
        }
    }
    // filter in action
    getFilteredData(e, data){
        let pageNum = this.state.pageNum,filterObj = data;
        if(e){
            e.preventDefault();
        } 
        this.props.submitFilter(data);
        this.getData(pageNum, filterObj);
    }
    render() {

        var workdays = this.props;             
        let status = this.props.queryParams.status;
        let greater12 = this.props.queryParams.greater12 ? true : false;
        
        var route = localStorage.getItem('route') ? localStorage.getItem('route') : '',
            compTitle = status == 'U' ? 'Non Certified HOS Logs' : status == 'C' ? 'Certified HOS Logs' : greater12 ? 'HOS Logs > 12 Hours' : constants.getComponentTitle(route);
            
            return (
                <AdminCommonSection compTitle={compTitle} admin={this.props.authDetails.role == constants.roles.ADMIN_ROLE}
                tblBody={
                <div>
                    <Filters getData = {(e, data) => this.getFilteredData(e, data)}/>
                    <PDFPrinting Page="Projects" pageNo = {this.state.pageNum} compTitle = {compTitle} logStatus = {status} greater12 = {greater12}/>
                   
                    <div id="tblMainActivities">
                        <table className="table table-striped table-bordered_header table-condensed">
                            <thead className="thead-default">
                                <tr className="text-center">
                                    <th className="text-center">Employee ID</th>
                                    <th className="text-center">First Name</th>
                                    <th className="text-center">Last Name</th>
                                    <th className="text-center">Service Date</th>
                                    <th className="text-center">Type</th>
                                    {!greater12 ? <th className="text-center hidden">14 Day Cycle</th> : null}
                                    {greater12 ? <th className="text-center">Total HOS</th> : null}
                                    <th className="text-center">Certify Date</th>
                                    <th className="text-center">Status</th>
                                </tr>

                            </thead>
                            <tbody>
                            {
                                this.renderWorkdays()
                            }
                            </tbody>
                        </table >
                        {
                            this.renderModal()
                        }
                        </div>
                        {
                            this.renderPagination()
                        }
                        </div>
                }/>
            )
        }
}

function mapStateToProps(state) {

    const queryParams = {status:''};
  

    return {
        workdays: state.workdays.workdays,
        isLoading: state.workdays.isLoading,
        showModal: state.modals.showModal,
        modalName: state.modals.modalName,
        workday: state.workday.workday,
        authDetails:state.authState,
        filterState:state.filter,
        queryParams: queryParams
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            fetchhoslogsWorkdays: fetchhoslogsWorkdays,
            submitFilter: filterAction,
            resetFilter:resetFilterAction
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(HOSLogsWorkDays);
